import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon, Button, Span, H2, H3, P } from 'components/Ui';
import { ArrowRightBlue } from 'images';
import { connect, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { replaceAllVariables, getToUrl } from 'utils/translation';
import { push } from 'connected-react-router';
import { selectCostcoVariables } from 'containers/Landing/selectors';
import content from '../quickShopContent';
import { SELECT_WATER, SELECT_EQUIPMENT, REVIEW_ORDER } from '../constants';
import SkipEquipment from '../SkipEquipment';
import styles from './styles.scss';
import PromotionValidation from '../PromotionValidation';

const Footer = ({
  page,
  nextStep,
  promotionApplied,
  onNext,
  cartItems,
  isCostco,
  disableNext,
  costcoVariables,
}) => {
  const promotionalPricingDisclaimer = replaceAllVariables(
    '{promotionalPricingDisclaimer}',
    costcoVariables,
    '',
  );

  const isSelectWaterPage = useMemo(() => page === SELECT_WATER, [page]);

  const quickShopContent = useMemo(
    () =>
      isSelectWaterPage ? content[SELECT_EQUIPMENT] : content[REVIEW_ORDER],
    [isSelectWaterPage],
  );

  const dispatch = useDispatch();

  return (
    <>
      <div className={classnames(styles.footer)}>
        <SkipEquipment
          promotionApplied={promotionApplied}
          step={nextStep}
          cartItems={cartItems}
          isCostco={isCostco}
          disableNext={disableNext}
        />
      </div>
      <div className={styles.disclaimer}>
        <small>
          <sup className={styles.supScript}>* </sup>
          <Span id="delivery-service-notes">
            Some areas subject to 4-week delivery based on service routes.
          </Span>
        </small>
        {isCostco && nextStep === 1 && (
          <div className={styles.terms}>
            <small>
              <span id="costco-promo-terms-id">
                {promotionalPricingDisclaimer}
              </span>
            </small>
          </div>
        )}
      </div>
    </>
  );
};

Footer.propTypes = {
  page: PropTypes.string.isRequired,
  onNext: PropTypes.func,
  nextStep: PropTypes.number,
  promotionApplied: PropTypes.bool,
  cartItems: PropTypes.array,
  isCostco: PropTypes.bool,
  disableNext: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  costcoVariables: selectCostcoVariables(),
});

export default connect(mapStateToProps, null)(Footer);
